import React from 'react';

export default function Input({
    label,
    hint,
    error,
    className = '',
    inputClassName = '',
    ...props
}) {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    {label}
                    {hint && <span className="text-xs text-gray-400 font-normal ml-1.5">{hint}</span>}
                </label>
            )}
            <input
                className={`h-9 w-full rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-1 disabled:bg-gray-50 disabled:text-gray-500 ${inputClassName}`}
                {...props}
            />
            {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
        </div>
    );
}
